import { createContext, useContext } from 'react';
export const ElementPropsContext = createContext(undefined);
export const useElementProps = ()=>useContext(ElementPropsContext) ?? {};
export const useElementClassName = (...path)=>{
    let level = useElementProps();
    let entry;
    for (const key of path){
        entry = level?.[key];
        level = entry?.elementProps;
    }
    return entry?.className;
};

//# sourceMappingURL=element-props-context.js.map